var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.charts),function(chart){return _c('EChart',{key:chart.name,attrs:{"loading":_vm.loading,"height":chart.height,"option":chart.option,"group":_vm.chartGroup}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }